
// secureStorageUtils.ts - Non-hook version for use outside components
import CryptoJS from 'crypto-js'; // You'll need to install this package

// This is a utility version that doesn't use React hooks
export const secureStorageUtils = {
  // Use a strong secret key - in production, this should be environment-specific
  secretKey: 'AGDY734353VY45VIB4V5645BV8V84VNVNNVN4V',

  // Set item with encryption
  setItem(key: string, value: string): void {
    try {
      const encryptedValue = CryptoJS.AES.encrypt(value, this.secretKey).toString();
      localStorage.setItem(key, encryptedValue);
    } catch (error) {
      console.error('Error encrypting value:', error);
    }
  },

  // Get item with decryption
  getItem(key: string): string | null {
    try {
      const encryptedValue = localStorage.getItem(key);
      if (!encryptedValue) return null;
      
      const decryptedBytes = CryptoJS.AES.decrypt(encryptedValue, this.secretKey);
      return decryptedBytes.toString(CryptoJS.enc.Utf8);
    } catch (error) {
      console.error('Error decrypting value:', error);
      return null;
    }
  },

  // Remove item
  removeItem(key: string): void {
    localStorage.removeItem(key);
  },

  // Clear all items
  clear(): void {
    localStorage.clear();
  }
};